import axios from "axios";
import { BASE_LOGIN_API_URL } from "../utility/URL";
import { headerConfig } from "../utility/RequestHeaderConfig";

const login = async (username, password,yearID) => {
  const response = await axios
    .post(BASE_LOGIN_API_URL + "authenticate", {
      username,
      password,
      yearID
    });
  // if (response.data.accessToken) {
  //   localStorage.setItem("user", JSON.stringify(response.data));
  // }
  return response.data;
};


const logout = () => {
  localStorage.removeItem("user");
};

const changePassword = async (data) => {
  const response = await axios.post(BASE_LOGIN_API_URL + "changepassword", data, headerConfig);
  return response.data;
};

const authService = {
  login,
  logout,
  changePassword
};
export default authService;